<!--
 * @Author: your name
 * @Date: 2022-03-15 13:42:42
 * @LastEditTime: 2022-07-29 17:10:19
 * @LastEditors: xuhuining
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \xingmahui_front\src\components\contents\toolCard.vue
-->

<template>
  <div class="toolCardWrap">
    <ul class="toolList">
      <li class="item" v-for="(item,index) in currentToolList" :key="index" @click="isLoginOrEdit(item,index)">
        <img class="img_tag" v-if="item.imgUrlMini" :src=item.imgUrlMini alt="">
        <div v-if="item.urlType !== 3">
          <img class="img" :src="item.imgUrl" alt="">
          <p class="name">{{item.name}}</p>
        </div>
        <div class="img-icon" v-if="item.urlType === 3"  @click="issystem ? goToMini('xmyxItem' + item.toolId + item.jumpUrl, item.jumpUrl, item.miniProgramType) : ''">
          <div class="img-container"  v-if="!issystem">
            <openWxTag :id="('xmyxItem' + item.toolId)"
              :path="item.jumpUrl"
              :appId="item.miniProgramTypeAppId"
              btnStyle="width:40px;height:40px">
            </openWxTag>
          </div>
          <img class="img" :src="item.imgUrl" alt="">
          <p class="name">{{item.name}}</p>
        </div>
      </li>
      <li class="item" v-if="currentToolList.length > 5" @click="toMoreTool">
        <img class="img" src="../../../assets/images/tools/newTools/more.png" alt="">
        <p class="name">更多</p>
      </li>
    </ul>
    <div class="moreTool" v-if="currentToolList.length <= 5" @click="toMoreTool">更多孕育工具<img src="../../../assets/images/nweHome/more.png" alt=""></div>
    <!-- 健康问诊登录弹窗 -->
    <loginTip
      :tipstr="'成为会员，立刻尊享免费问诊权益哟～(๑•ᴗ•๑)♡'"
      :okText="'立即领取'"
      :closeText="'狠心放弃'"
      :messageText="''"
      :show="checkLogin"
      @confirmWay="confirmWay"
      @cancleWay="cancleWay"
    ></loginTip>
    <!-- 扫码提示弹窗 -->
    <granary-dialog
      v-show="dialogShow"
      @closeDialog="cancelDialog"
      @wxScanFn="weiScanSHnader()"
    ></granary-dialog>
  </div>
</template>

<style lang="less" scoped>
 @import './less/index.less';
</style>

<script>
import Index from "./js/index";
export default Index;
</script>

